import React from 'react'

import { graphql, useStaticQuery } from 'gatsby'
import { Trans } from 'gatsby-plugin-react-i18next'

import { Row, ContentContainer, Header, Title, Text, TextContainer, MealImage } from './styles'

import { PlusBubble, BubbleText } from '../CalendarNewFeatures/styles'

import { CAL_MAX_FEATURES } from './constants'

const CalMaxFeatures = () => {
  const { meal, all, auto, plan, sidekick, habit, rewards, lists } = useStaticQuery(graphql`
    query CalMaxFeaturesQuery {
      meal: file(relativePath: { eq: "calmax/meal.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      all: file(relativePath: { eq: "calmax/temp/all-in-one.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      auto: file(relativePath: { eq: "calmax/temp/calendar-auto-syncing.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      plan: file(relativePath: { eq: "calmax/temp/planning.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      sidekick: file(relativePath: { eq: "calmax/temp/sidekick.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      habit: file(relativePath: { eq: "calmax/temp/routines-chores.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      rewards: file(relativePath: { eq: "calmax/temp/rewards.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      lists: file(relativePath: { eq: "calmax/temp/instacart-custom-list.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
    }
  `)
  const features = [
    { d: all, color: '#A6C9DF' },
    { d: auto, color: '#F5C67A' },
    { d: plan, color: '#BDBDBD' },
    { d: sidekick, color: '#F3C6BC' },
    {
      d: habit,
      color: '#7EB6B6',
    },
    {
      d: rewards,
      color: '#A6C9DF',
    },
    {
      d: meal,
      color: '#DCB68C',
    },
    {
      d: lists,
      color: '#F3C6BC',
    },
  ]

  return (
    <ContentContainer>
      <Header>Designed to Delight</Header>
      {CAL_MAX_FEATURES.map((feature, i) => (
        <Row key={i} color={features[i].color} reverse={i % 2 === 0}>
          <MealImage
            image={features[i].d.childImageSharp.gatsbyImageData}
            alt={CAL_MAX_FEATURES[i].alt}
          />
          <TextContainer extra={i === 1}>
            {feature.plus && (
              <PlusBubble>
                <BubbleText>Calendar Plus</BubbleText>
              </PlusBubble>
            )}
            <Title>
              <Trans>{feature.title}</Trans>
            </Title>
            <Text>
              <Trans>{feature.text}</Trans>
            </Text>
          </TextContainer>
        </Row>
      ))}
    </ContentContainer>
  )
}

export default CalMaxFeatures
